
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37.826 14.495h-1.31c.173-.274.287-.581.32-.906.103-1.04-.443-1.971-1.374-2.384a2.298 2.298 0 00-2.508.404l-1.655 1.502a1.756 1.756 0 00-2.6.001l-1.657-1.503a2.3 2.3 0 00-2.508-.404c-.93.413-1.477 1.345-1.373 2.384.033.325.147.632.32.906h-1.307c-.648 0-1.174.526-1.174 1.176v1.763c0 .324.263.587.587.587h16.826a.587.587 0 00.587-.587V15.67c0-.649-.526-1.175-1.174-1.175zm-9.587-.196v.196h-2.761a1.16 1.16 0 01-1.122-1.442c.08-.335.322-.62.634-.765a1.129 1.129 0 011.264.192l1.986 1.802v.017zm7.431-.867c-.043.611-.594 1.063-1.206 1.063h-2.703V14.278l1.954-1.774c.3-.272.721-.4 1.11-.284.558.167.886.642.845 1.212zm-13.496 5.772v8.62c0 .65.525 1.176 1.174 1.176h5.478v-9.796h-6.652zM31.178 29v-9.796h6.652v8.62c0 .65-.525 1.176-1.173 1.176h-5.479z","fill":"#fff"}})])
          )
        }
      }
    